import { CONTACT_ITEMS } from "@/data/linksData";
import React from "react";

const ContactFooter = () => {
  return (
    <div>
      <h3 className="mb-4 text-lg font-semibold">Contact Info</h3>
      <div className="flex flex-col gap-4 text-base text-gray-400">
        {CONTACT_ITEMS.map((item, index) => {
          const Icon = item.icon;
          return (
            <div
              key={index}
              className={`flex items-start gap-2 ${index === 0 ? "items-center" : "items-start"
                }`}
            >
              <span className="shrink-0"><Icon /></span>
              <span>{item.value}</span>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default ContactFooter;
